import React, { Component } from 'react'
import { Table } from 'semantic-ui-react'

export default class DocumentAttributes extends Component {

  render() {
    const data = this.props.data
    const keys = Object.keys(data);

    return (
      <Table celled striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell colSpan="2">
              Document Details
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {
            keys.map((key, i) => {
              return (
                <Table.Row key={key}>
                  <Table.Cell key={data[key]}>
                    {key.toString()}
                  </Table.Cell>
                  <Table.Cell>
                    {data[key].toString()}
                  </Table.Cell>
                </Table.Row>
              );
            })
          }
        </Table.Body>
      </Table>
    );
  }
}


// WEBPACK FOOTER //
// ./src/component/DocumentAttributes.js